import { PanelRow, ToggleControl, FormTokenField, Dropdown, Button, RangeControl, TextControl, Notice, IconButton } from '@wordpress/components'
import { dispatch, useSelect } from '@wordpress/data'
import { useState, useEffect } from '@wordpress/element';

import { __ } from '@wordpress/i18n'

export default ({priceIndex, catIndex}) => {
    const {pricings} = useSelect((select) => {
        return select('WPTravel/TripEdit').getAllStore()
    }, []);
    const { updateTripPricing } = dispatch('WPTravel/TripEdit');

    let price = pricings[priceIndex];
    let priceCategory = 'undefined' === typeof pricings[priceIndex].categories[catIndex] ? [] : pricings[priceIndex].categories[catIndex]

    // let has_group_price = 'undefined' === typeof price.has_group_price ? false : price.has_group_price;
    let pricing_has_group_price = 'undefined' === typeof price.has_group_price ? false : price.has_group_price;
    let has_group_price         = 'undefined' === typeof priceCategory.has_group_price ? false : priceCategory.has_group_price;

    let group_prices = 'undefined' === typeof priceCategory.group_prices ? [] : priceCategory.group_prices;
    let addGroupPrice = ()=>{
        let priceData = price;
        let priceCategoryData = priceCategory

        priceCategoryData.group_prices = [...group_prices, {
            min_pax:'',
            max_pax:'',
            price:''
        }];
        priceData.categories[catIndex] = priceCategoryData
        updateTripPricing(priceData, priceIndex)
    }
    return <>
        {! pricing_has_group_price &&
        <>
            <hr/>
            <PanelRow>
                <label>{__( 'Enable Group Price','wp-travel-pro' )}</label>
                    <div className="text-right">
                        <ToggleControl
                            checked={ priceCategory.has_group_price }
                            onChange={ () => {
                                let priceData = price;
                                let priceCategoryData = priceCategory
                                priceCategoryData.has_group_price = ! priceCategory.has_group_price;

                                priceData.categories[catIndex] = priceCategoryData
                                updateTripPricing(priceData, priceIndex)
                            } }
                        />
                    </div>
            </PanelRow>
        </>
        }

        { has_group_price && ! pricing_has_group_price && <>
            <PanelRow className="wp-travel-has-child-panel">
                <label>{__( 'Group Prices','wp-travel-pro' )}</label>
            </PanelRow>
            <PanelRow className="wp-travel-has-child-panel">
                {group_prices.length > 0 ?
                <table className="wp-list-table widefat  striped ">
                    <thead>
                        <tr>
                            <td>{__( 'Min Pax','wp-travel-pro' )}</td>
                            <td>{__( 'Max Pax','wp-travel-pro' )}</td>
                            <td>{__( 'Price','wp-travel-pro' )}</td>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        { group_prices.length > 0 ? group_prices.map((groupPrice, groupPriceIndex)=><tr>
                            <td><TextControl
                                type="number"
                                min="0"
                                autoComplete="off"
                                value={groupPrice.min_pax} onChange={(min_pax)=>{
                                let priceData = price;
                                let priceCategoryData = priceCategory
                                priceCategoryData.group_prices[groupPriceIndex].min_pax = min_pax
                                priceData.categories[catIndex] = priceCategoryData
                                updateTripPricing(priceData, priceIndex);
                            }}/></td>
                            <td><TextControl
                                type="number"
                                min="0"
                                autoComplete="off"
                                value={groupPrice.max_pax} onChange={(max_pax)=>{
                                let priceData = price;
                                let priceCategoryData = priceCategory
                                priceCategoryData.group_prices[groupPriceIndex].max_pax = max_pax
                                priceData.categories[catIndex] = priceCategoryData
                                updateTripPricing(priceData, priceIndex);
                            }} /></td>
                            <td><TextControl value={groupPrice.price}  onChange={(gprice)=>{
                                let priceData = price;
                                let priceCategoryData = priceCategory
                                priceCategoryData.group_prices[groupPriceIndex].price = gprice
                                priceData.categories[catIndex] = priceCategoryData
                                updateTripPricing(priceData, priceIndex);
                            }}/></td>
                            <td><IconButton
                                icon="trash"
                                label="Delete"
                                onClick={()=>{
                                    if ( ! confirm(  __( 'Are you sure to delete group price?','wp-travel-pro' )  ) ) {
                                        return false;
                                    }
                                    let priceData = price;
                                    let priceCategoryData = priceCategory
                                    priceCategoryData.group_prices = group_prices.filter((groupPriceFilter,groupPriceFilterIndex)=>{
                                        return groupPriceIndex!=groupPriceFilterIndex;
                                    });
                                    priceData.categories[catIndex] = priceCategoryData
                                    
                                    updateTripPricing(priceData, priceIndex)
                                }}
                            /></td>
                        </tr>):<tr><td colSpan="4">{ __( 'No Group Price.','wp-travel-pro' ) }</td></tr>}
                        
                    </tbody>
                </table>:<Notice isDismissible={false} actions={[{
                    'label':'Add Group Price',
                    onClick:()=>{
                        addGroupPrice()
                    },
                    noDefaultClasses:true,
                    className:'is-link'
                }]}>{ __( 'No Group Price found.','wp-travel-pro' ) }</Notice>}
            </PanelRow>
            
            {group_prices.length > 0 &&
            <PanelRow className="wp-travel-action-section has-right-padding">
                <span></span>
                <Button isDefault onClick={()=>addGroupPrice()}>{ __( '+ Add Group Price','wp-travel-pro' ) }</Button>
                            
            </PanelRow>} </>}
    </>
    
    
}